import React, { useState, useEffect } from 'react'
import AdminNavbar from '../components/AdminNavbar'
import AdminHeader from '../components/AdminHeader'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter } from '../utils/AppFunctions'
import config from '../app-config'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { isMobile } from '../utils/helper'
import { MdSupport, MdSupportAgent } from 'react-icons/md'
import Support from '../components/Support'

export default function AdminLayout({ children, navSelected, regularContainer, toolbar }) {
    const navigate = useNavigate()
    const [showNavbar, setShowNavbar] = useState(true)
    const { isAuthorised, userRole } = useFetchAuthorisation("user")
    const [applicationWidth, setApplicationWidth] = useState(window.innerWidth)
    const [showSupport, setShowSupport] = useState(false)

    useEffect(() => {
        window.addEventListener('resize', () => {
            setApplicationWidth(window.innerWidth)
        })
    }, [])

    return (
        <>
            <div style={{ width: "100dvw", }}>
                <ToastContainer />
                <div className='row' style={{ width: "100%" }}>
                    {(showNavbar || !isMobile(applicationWidth)) && <AdminNavbar selected={navSelected} />}
                    {showNavbar && isMobile(applicationWidth) &&
                        <div className={`fixed h-dvh right-0 top-0 w-[calc(100dvw-240px)]`} onClick={() => setShowNavbar(!showNavbar)}>
                            <i className="fas fa-bars"></i>
                        </div>
                    }
                    <div style={{ width: "100%", maxHeight: "100dvh", overflowY: "scroll", }}>
                        <AdminHeader showNavbar={showNavbar} setShowNavbar={setShowNavbar} />
                        {toolbar && (
                            <div className="bg-white shadow-sm border-b border-gray-200 sticky top-16 z-40">
                                <div className="mx-auto px-4 sm:px-6 lg:px-8">
                                    <div className="flex items-center justify-between h-16">
                                        {toolbar}
                                    </div>
                                </div>
                            </div>
                        )}
                        {!regularContainer ?
                            <div className="container" style={{ width: "100%" }}>
                                <div className="inner-container" style={{ width: "100%" }}>
                                    {children}
                                </div>
                            </div>

                            :
                            <div className="reg-container" style={{ width: "100%" }}>
                                {children}
                            </div>
                        }
                    </div>
                </div>
            </div>
            {showSupport ? <div className="fixed bottom-10 right-10" style={{ zIndex: 1000 }}>
                <div className="bg-white p-4 rounded-lg shadow-lg border border-gray-200">
                    <div className="flex justify-between items-center mb-2">
                        <h3 className="text-lg font-semibold text-gray-800">Support</h3>
                        <button
                            onClick={() => setShowSupport(false)}
                            className="text-gray-500 hover:text-gray-700 focus:outline-none"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <div className="text-sm text-gray-600">
                        <Support />
                    </div>
                </div>
            </div>
                : <div className="fixed bottom-10 right-10" style={{ zIndex: 1000 }}>
                    <button
                        onClick={() => setShowSupport(true)}
                        className="text-white p-6 rounded-full shadow-lg hover:bg-blue-700 focus:outline-none" style={{ backgroundColor: "var(--primary)" }}
                    >
                        <MdSupportAgent size={30} />
                    </button>
                </div>
            }

        </>
    )
}
